/* eslint-disable import/no-extraneous-dependencies */
import { useScreenSize } from '@hooks';
import Camo from '@pngs/Camo.png';
import Compass from '@pngs/Compass.png';
import Net from '@pngs/NetVertical.png';
import { Flex, Image, theme, Typography } from '@styles';
import { number, shape } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import {
  Decoration,
  imgProps,
  StyledDecoration,
  StyledFlex,
  StyledTypographyBanner,
  StyledWrapper,
} from '../../AboutUsPage.layoutProps';

const Banner = ({ dynamicWidth, layout }) => {
  const { isTabletLG, isTabletSM } = useScreenSize();
  const { i18n } = useTranslation();

  return (
    <Flex
      backgroundColor={theme.colors.background}
      mb={isTabletLG ? 0 : 150}
      position="relative"
      width="100%"
    >
      <Flex
        backgroundColor={theme.colors.schoolBusYellow[100]}
        bottom="0"
        height="68px"
        left="17%"
        position="absolute"
        style={{
          zIndex: 5,
        }}
        width={`${Math.round(dynamicWidth / 28) || 52}px`}
      />
      <Flex
        backgroundColor={theme.colors.schoolBusYellow[100]}
        bottom="0"
        height="169px"
        left="17%"
        position="absolute"
        style={{
          zIndex: 5,
        }}
        width={`${Math.round(dynamicWidth / 43) || 34}px`}
      />
      <Flex
        backgroundColor={theme.colors.schoolBusYellow[100]}
        bottom="0"
        display={isTabletLG ? 'none' : 'block'}
        height="564px"
        position="absolute"
        right={0}
        style={{
          transform: 'translate(0, -75%)',
          zIndex: 5,
        }}
        width={9}
      />
      <Flex
        backgroundImage={Camo}
        backgroundSize="auto"
        height={500}
        position="absolute"
        right={0}
        top={0}
        width={624}
      />
      <Flex
        backgroundImage={Net}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height={1200}
        position="absolute"
        right={0}
        style={{
          transform: 'translate(0, -50%)',
        }}
        top={0}
        width={624}
      />
      {!isTabletSM && (
        <Image
          alt="compass"
          bottom="0"
          height={250}
          right="0"
          width={250}
          {...(isTabletLG && { left: 'none', right: 0 })}
          position="absolute"
          src={Compass}
          style={{
            transform: `translate(${isTabletLG ? 50 : -50}%, 50%)`,
            zIndex: 5,
          }}
        />
      )}
      <Decoration as={StyledDecoration} height={26} width={230} />
      <StyledFlex bottom="0" height="100%" position="absolute" width="100%" />
      <Flex
        backgroundColor={theme.colors.schoolBusYellow[100]}
        bottom="0"
        height="169px"
        left="17%"
        position="absolute"
        style={{
          zIndex: 5,
        }}
        width={`${Math.round(dynamicWidth / 43) || 34}px`}
      />
      <Flex
        backgroundColor={theme.colors.schoolBusYellow[100]}
        bottom="0"
        height="68px"
        left="17%"
        position="absolute"
        style={{
          zIndex: 5,
        }}
        width={`${Math.round(dynamicWidth / 28) || 52}px`}
      />
      <Flex
        flexDirection="column"
        overflow="hidden"
        position="relative"
        width="100%"
      >
        <StyledWrapper flexDirection="column" general px={layout?.px}>
          <Typography
            color={theme.colors.white[100]}
            mt="5px"
            variant={isTabletLG ? 'BN-bold-s80-lh84' : 'BN-bold-s123-lh104'}
          >
            {i18n.t('AboutUs.Banner.Title')}
          </Typography>
          <StyledWrapper>
            <StyledTypographyBanner withoutMB>
              {i18n.t('AboutUs.Banner.Description1')}
            </StyledTypographyBanner>
            <StyledTypographyBanner>
              {i18n.t('AboutUs.Banner.Description2')}
            </StyledTypographyBanner>
          </StyledWrapper>
        </StyledWrapper>
        <Flex justifyContent="space-between" minWidth="1000px" width="100%">
          <Flex
            display="inline-flex"
            position="relative"
            style={{ zIndex: isTabletLG ? 2 : 0 }}
          >
            {imgProps.slice(0, 3).map((png) => (
              <Flex
                key={uuidv4()}
                backgroundColor={theme.colors.background}
                display="block"
                height="auto"
              >
                <Image
                  height={isTabletLG ? '400px' : '100%'}
                  src={png.src}
                  width={isTabletLG ? 'auto' : png.width}
                />
              </Flex>
            ))}
          </Flex>

          <Flex display="inline-flex" position="relative" style={{ zIndex: 2 }}>
            {imgProps.slice(3, 5).map((png) => (
              <Flex
                key={uuidv4()}
                backgroundColor={theme.colors.background}
                display="block"
                height="auto"
              >
                <Image
                  height={isTabletLG ? '400px' : '100%'}
                  src={png.src}
                  width={isTabletLG ? 'auto' : png.width}
                />
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

Banner.propTypes = {
  dynamicWidth: number,
  layout: shape.isRequired,
};
Banner.defaultProps = {
  dynamicWidth: 0,
};
export default Banner;
